import { autoinject } from 'aurelia-framework';
import { TokenClient } from '../../../services/authentication/token-client.service';
import { UserClientService } from '../../../services/authentication/user-client.service';
import { Router } from 'aurelia-router';
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { RightShipQiRouterConstants } from '../../../configuration/rightshipqi-router.constants';
import { UrlHelper } from '../../../helpers/url-helper';
import { RegexHelper } from '../../../helpers/regex-helper';

@autoinject
export class GenericRedirectCallback {

	constructor(private tokenClient: TokenClient,
		private userClientService: UserClientService,
		private requestClient: RequestClientService, private router: Router) {

	}

	async activate() {
		const isAuthenticated = this.userClientService.currentUser && this.userClientService.currentUser.id >= 0;
		if (isAuthenticated) {
			await this.navigate("", false);
		} else {
			try {
				await this.tokenClient.loginWithProvider('auth0', undefined, false);
				await this.loadXSRFToken();
				this.requestClient.loadConfigurationHeaders();
				await this.navigate("");
			} catch (x) {
				await this.handleCatchResponse(x);
			}
		}
	}

	async navigate(route: string, reloadUser: boolean = true) {
		let referrer = this.getUrlParameter("referrer");
		if (referrer) {
			const s = referrer.split(window.location.origin);
			if (s && s.length > 1) {
				if (reloadUser) await this.userClientService.reloadUser();
				this.router.navigate(s[1]);
			}
			else {
				referrer = UrlHelper.insertURLParameter(referrer, 'from-platform', 'true');
				window.location.href = referrer;
			}
		} else {
			if (reloadUser) await this.userClientService.reloadUser();
			this.router.navigate(route);
		}
	}

	loadXSRFToken(): Promise<any> {
		return this.requestClient.get<any>('Auth0/LoadXSRFToken', {});
	}

	getUrlParameter(name) {
		name = RegexHelper.escapeSquareBrackets(name);
		const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		const results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	async handleCatchResponse(x: { response: string, responseType: string }) {
		if (x && x.responseType == "json" && x.response) {
			try {
				const parsedResponse = JSON.parse(x.response);
				if (parsedResponse && Object.keys(parsedResponse).indexOf("key") > -1 && parsedResponse.key == "customer-trial-expired") {
					await this.navigate("");
				}
				else {
					this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.RightShipNotAuthorized);
				}
			} catch (e) {
				console.error(e);
				this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.RightShipNotAuthorized);
			}
		}
		else this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.RightShipNotAuthorized);
	}
}
